import { render } from "./ExpanderColorSelector.vue?vue&type=template&id=dbb200c2&scoped=true"
import script from "./ExpanderColorSelector.vue?vue&type=script&lang=js"
export * from "./ExpanderColorSelector.vue?vue&type=script&lang=js"

import "./ExpanderColorSelector.vue?vue&type=style&index=0&id=dbb200c2&scoped=true&lang=scss"

import exportComponent from "/Users/ondrej/dev/www/_showheroes/2023/norway/honda-w37/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb200c2"]])

export default __exports__